<template>
  <b-modal
    id="modal-supplier-document-filter"
    ok-title="Submit"
    cancel-variant="outline-secondary"
    centered
    title="過瀘"
    headerClass="pr-3 py-2 border-bottom bgWhite"
    footerClass="px-3 py-2 border-top bgWhite"
    hide-footer
    no-close-on-backdrop
    size="lg"
  >
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-form class="mt-1" @submit.prevent="onSubmit">
        <b-row>
          <!-- 開支類型篩選 -->
          <b-col cols="12">
            <b-form-group
              label="開支類型："
              label-for="filter_expense_type"
              label-cols-md="3"
            >
              <v-select
                id="filter_expense_type"
                v-model="update.filter_expense_type"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="expenseTypeOptions"
                :clearable="true"
                label="label"
                :reduce="(option) => option.value"
                placeholder="選擇開支類型"
              >
              </v-select>
            </b-form-group>
          </b-col>

          <!-- 埋數狀態篩選 -->
          <b-col cols="12">
            <b-form-group
              label="埋數狀態："
              label-for="filter_approval_status"
              label-cols-md="3"
            >
              <v-select
                id="filter_approval_status"
                v-model="update.filter_approval_status"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="approvalStatusOptions"
                :clearable="true"
                label="label"
                :reduce="(option) => option.value"
                placeholder="選擇埋數狀態"
              >
              </v-select>
            </b-form-group>
          </b-col>

          <!-- 供應商篩選 -->
          <b-col cols="12">
            <b-form-group
              label="供應商："
              label-for="filter_supplier_id"
              label-cols-md="3"
            >
              <v-select
                id="filter_supplier_id"
                v-model="update.filter_supplier_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="supplierOptions"
                :clearable="true"
                label="name_cn"
                :reduce="(option) => option.id"
                placeholder="選擇供應商"
                :filter="supplierSearch"
              >
                <!-- <template #option="{ name, name_cn }">
                  {{ name_cn }}
                </template>
                <template #selected-option="{ name, name_cn }">
                  {{ name_cn }}
                </template> -->
              </v-select>
            </b-form-group>
          </b-col>

          <!-- 日期範圍篩選 -->
          <b-col cols="12">
            <b-form-group
              label="開始日期："
              label-for="filter_date_from"
              label-cols-md="3"
            >
              <flat-pickr
                id="filter_date_from"
                v-model="update.filter_date_from"
                class="form-control"
                :config="{
                  allowInput: true,
                  altInput: true,
                  altFormat: 'Y-m-d',
                  dateFormat: 'Y-m-d',
                }"
                placeholder="選擇開始日期"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group
              label="結束日期："
              label-for="filter_date_to"
              label-cols-md="3"
            >
              <flat-pickr
                id="filter_date_to"
                v-model="update.filter_date_to"
                class="form-control"
                :config="{
                  allowInput: true,
                  altInput: true,
                  altFormat: 'Y-m-d',
                  dateFormat: 'Y-m-d',
                }"
                placeholder="選擇結束日期"
              />
            </b-form-group>
          </b-col>
        </b-row>
        
        <div class="d-flex mt-2 justify-content-end">
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="resetFilters"
            class="mr-1"
          >
            重置
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            variant="outline-danger"
            class="mr-1"
            @click="hide"
          >
            取消
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            type="submit"
          >
            <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
            提交
          </b-button>
        </div>
      </b-form>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BButton,
  BModal,
  VBModal,
  BCardText,
  BOverlay,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BCardBody,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import flatPickr from "vue-flatpickr-component";
import ability from "@/libs/acl/ability";

export default {
  name: "ModalSupplierDocumentFilter",
  components: {
    BButton,
    BModal,
    BCardText,
    BOverlay,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BCardBody,
    vSelect,
    flatPickr,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  methods: {
    hide() {
      this.$bvModal.hide("modal-supplier-document-filter");
    },
    onSubmit() {
      // 日期驗證
      if (this.update.filter_date_from && this.update.filter_date_to) {
        const dateFrom = new Date(this.update.filter_date_from);
        const dateTo = new Date(this.update.filter_date_to);
        
        if (dateFrom > dateTo) {
          this.$swal({
            text: "開始日期不能晚於結束日期",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            showClass: {
              popup: "animate__animated animate__bounceIn",
            },
            buttonsStyling: false,
          });
          return;
        }
      }

      this.$emit("update:filter_expense_type", this.update.filter_expense_type);
      this.$emit("update:filter_approval_status", this.update.filter_approval_status);
      this.$emit("update:filter_supplier_id", this.update.filter_supplier_id);
      this.$emit("update:filter_date_from", this.update.filter_date_from);
      this.$emit("update:filter_date_to", this.update.filter_date_to);
      this.hide();
    },
    resetFilters() {
      this.update = {
        filter_expense_type: null,
        filter_approval_status: null,
        filter_supplier_id: null,
        filter_date_from: null,
        filter_date_to: null,
      };
    },
    supplierSearch(options, search) {
      return options.filter((item) => {
        if (!item || !search) return true;
        return (
          (item.name && item.name.toLowerCase().includes(search.toLowerCase())) ||
          (item.name_cn && item.name_cn.toLowerCase().includes(search.toLowerCase()))
        );
      });
    },
  },
  props: {
    expenseTypeOptions: {
      type: Array,
      required: true,
    },
    approvalStatusOptions: {
      type: Array,
      required: true,
    },
    supplierOptions: {
      type: Array,
      required: true,
    },
    filter_expense_type: {},
    filter_approval_status: {},
    filter_supplier_id: {},
    filter_date_from: {},
    filter_date_to: {},
  },
  data() {
    return {
      loading: false,
      ability,
      update: {
        filter_expense_type: null,
        filter_approval_status: null,
        filter_supplier_id: null,
        filter_date_from: null,
        filter_date_to: null,
      },
    };
  },
  watch: {
    // 監聽 props 變化並同步到 update 物件
    filter_expense_type(newVal) {
      this.update.filter_expense_type = newVal;
    },
    filter_approval_status(newVal) {
      this.update.filter_approval_status = newVal;
    },
    filter_supplier_id(newVal) {
      this.update.filter_supplier_id = newVal;
    },
    filter_date_from(newVal) {
      this.update.filter_date_from = newVal;
    },
    filter_date_to(newVal) {
      this.update.filter_date_to = newVal;
    },
  },
  mounted() {
    // 初始化時同步 props 到 update 物件
    this.update = {
      filter_expense_type: this.filter_expense_type,
      filter_approval_status: this.filter_approval_status,
      filter_supplier_id: this.filter_supplier_id,
      filter_date_from: this.filter_date_from,
      filter_date_to: this.filter_date_to,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
